import { AppState } from '@aes/core/core.state';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';
import { IModular } from '../model';
import { AppSwitcherService } from './app-switcher.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-switcher',
  templateUrl: './app-switcher.component.html',
  styleUrls: ['./app-switcher.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})

export class AppSwitcherComponent implements OnInit, OnDestroy {

  @Input() size: string;

  @Output()
  navigationApp: EventEmitter<any> = new EventEmitter<any>();

  gapSize = '26px';
  modularList: IModular[];
  keyApp: string;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _appSwitcherService: AppSwitcherService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,

  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this._appSwitcherService
    .getModuleState()
    .pipe(takeUntil(this.destroy$))
    .subscribe((response) => {
      this.modularList = response;
    });

    this.gapSize = this.size === 's-size' ? '48px' : '26px';
    this.keyApp = this._activatedRoute.snapshot?.firstChild?.routeConfig?.path;
  }

  navigationModular(modular: IModular): void {
    this.navigationApp.emit('clicked');
    this._router.navigate([modular.url]);
  }
}
